<template>
  <div class="uploadImg">
    <Upload
      v-if="!imgName"
      ref="upload"
      :show-upload-list="false"
      :on-success="handleSuccess"
      :format="['jpg','jpeg','png','bmp']"
      :max-size="2048"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
      multiple
      type="drag"
      :action="URL_BASE"
      name="multipartFile"
      style="display: inline-block;width:106px;">
      <div style="width: 106px;height:80px;line-height: 80px;">
        <Icon type="plus" size="20"></Icon>
      </div>
    </Upload>
    <div class="demo-upload-list" v-if="imgName">
        <img :src="img" width="106px" height="80px">
        <div class="demo-upload-list-cover" @click="handleRemove()">
          <Icon type="ios-trash-outline" ></Icon>
        </div>
    </div>
  </div>
</template>
<script>

  export default {
    props:{
      imgName:{type:String},
      editable:{type:Boolean,default:true}
    },
    data(){
      return {
        URL_BASE:`${process.env.API_URL_BASE}/commons/attachments/uploadTmp.do`,
        modalVisible:false
      }
    },
    methods:{
      handleView () {
        this.modalVisible = true;
      },
      handleSuccess (res, file) {
        console.log(1);
        this.$emit('update:imgName',file.response.data)
      },
      handleFormatError (file) {
        this.$Message.error('图片上传失败');
      },
      handleMaxSize () {
        this.$Message.error('图片大小不能超过2M');
      },
      handleRemove(){
        this.$emit('update:imgName','')
      }
    },
    computed:{
      img:function(){
        return `${process.env.API_URL_BASE}/commons/attachments/download.do?filename=${this.imgName}`
      },
    }
  }
</script>
<style lang="less" scoped>
  .demo-upload-list{
    display: inline-block;
    width: 106px;
    height: 80px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
    display: inline-block;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
    line-height:80px;

  }
</style>




// WEBPACK FOOTER //
// src/components/AppUploadImg.vue